import { render, staticRenderFns } from "./moreSelectProportion.vue?vue&type=template&id=df1f3fe8&"
import script from "./moreSelectProportion.vue?vue&type=script&lang=js&"
export * from "./moreSelectProportion.vue?vue&type=script&lang=js&"
import style0 from "./moreSelectProportion.vue?vue&type=style&index=0&id=df1f3fe8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports